import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { ApiService, nonFalsyPayload } from "../core";
import {
  CreateCustomWidgetPostDto,
  LocationWidgetSettingsGetDto,
  LocationWithDefaultWidgetGetDto,
  OneTimePaymentMethodGetDto,
  UpdateCustomWidgetPutDto,
  WidgetGetDto,
  WidgetSettingsGetDto
} from "../dto";
import { LocationWidgetSettingsMode } from "../enums";

@Injectable({
  providedIn: "root"
})
export class WidgetManagementService {
  private serviceUrl = "widgetManagement";

  constructor(private api: ApiService) {}

  getUserWidgets(locationId: number): Observable<WidgetSettingsGetDto[]> {
    return this.api.get(`${this.serviceUrl}/userWidgets/${locationId}`);
  }

  getWidgetsForAdmin({ excludeMerchantUse = false }: { excludeMerchantUse?: boolean } = {}): Observable<WidgetGetDto[]> {
    const params = nonFalsyPayload({ excludeMerchantUse });
    return this.api.get(`${this.serviceUrl}/widgets/admin`, params);
  }

  getAccountWidgets({ excludeMerchantUse = false }: { excludeMerchantUse?: boolean } = {}): Observable<WidgetGetDto[]> {
    const params = nonFalsyPayload({ excludeMerchantUse });
    return this.api.get(`${this.serviceUrl}/userWidgets/account`, params);
  }

  createCustomWidget(payload: CreateCustomWidgetPostDto) {
    return this.api.post(`${this.serviceUrl}/createCustomWidget`, payload);
  }

  updateCustomWidget(payload: UpdateCustomWidgetPutDto) {
    return this.api.put(`${this.serviceUrl}/updateCustomWidget`, payload);
  }

  deleteCustomWidget(id: number) {
    return this.api.delete(`${this.serviceUrl}/${id}`);
  }

  getLocationDefaultWidgets(locationId: number, mode = LocationWidgetSettingsMode.Cmc): Observable<LocationWithDefaultWidgetGetDto[]> {
    return this.api.get<LocationWithDefaultWidgetGetDto[]>(`${this.serviceUrl}/locationDefaultWidgets/${locationId}?mode=${mode}`);
  }

  updateLocationCampaign(locationWidget: LocationWidgetSettingsGetDto, mode = LocationWidgetSettingsMode.Cmc) {
    return this.api.put(`${this.serviceUrl}/updateLocationCampaign?mode=${mode}`, locationWidget);
  }

  getPaymentMethods(): Observable<OneTimePaymentMethodGetDto[]> {
    return this.api.get<OneTimePaymentMethodGetDto[]>(`${this.serviceUrl}/widgets/oneTimePayment/paymentMethods`);
  }
}
